import application from 'application/application';

import template from './inss-list.template.html';
import controller from './inss-list.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider
			.state('root.default.movements.inss', {
				url: '/inss?paginaAtual',
				views: {
					'movements@root.default.movements': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'INSS'
				}
			})
			.state('root.default.movements.inss1', {
				url:
					'/inss/processos/:processId?numeroProcesso&paginaAtual&idProcesso&pastaProcesso&dataInicial&dataFinal&lido&andamento',
				views: {
					'movements@root.default.movements': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'INSS'
				}
			});
	}
]);
